import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/img/rtlhu_page_loader.gif'


const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "search__loader"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "RTL.hu"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_celebrity_card_list = _resolveComponent("celebrity-card-list")!
  const _component_content_list_page = _resolveComponent("content-list-page")!

  return (_openBlock(), _createBlock(_component_content_list_page, null, {
    before: _withCtx(() => [
      _createElementVNode("form", {
        class: "search",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchByInput && _ctx.searchByInput(...args)), ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "search__input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          disabled: _ctx.searchLoading,
          placeholder: "Keresés...",
          autofocus: ""
        }, null, 8, _hoisted_1), [
          [_vModelText, _ctx.searchText]
        ]),
        _createElementVNode("button", {
          class: "search__button",
          type: "submit",
          disabled: _ctx.searchLoading
        }, [
          _createVNode(_component_Search)
        ], 8, _hoisted_2)
      ], 32),
      (_ctx.searchLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_ctx.searchResults)
          ? (_openBlock(), _createBlock(_component_celebrity_card_list, {
              key: 1,
              class: "search__list",
              contents: _ctx.searchResults?.items,
              cols: 6,
              "small-grid": true
            }, null, 8, ["contents"]))
          : _createCommentVNode("", true)
    ]),
    default: _withCtx(({ contentList }) => [
      _createVNode(_component_celebrity_card_list, {
        contents: contentList?.items,
        cols: 6,
        "small-grid": true
      }, null, 8, ["contents"])
    ]),
    _: 1
  }))
}